import React from "react";

const SecondaryButton = ({ onClick, text }) => {
  return (
    <button className="bg-primary-2 py-s px-m bg-primary1-hover" onClick={onClick}>
      <div className="button-text ">{text}</div>
    </button>
  );
};

export default SecondaryButton;
